<template>
  <!-- 修改字典对话框 -->
  <el-dialog
      title="修改字典"
      :visible.sync="editDialogVisible"
      width="600px"
  >
    <el-form ref="editFormRef" :rules="rules" :model="editForm" label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="模板名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入模板名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="模板路径" prop="path">
            <el-input v-model="editForm.path" placeholder="请输入模板路径"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="模板内容" prop="content">
            <el-input v-model="editForm.content" placeholder="请输入模板内容"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="模板关键字" prop="keyword">
            <el-input v-model="editForm.keyword" placeholder="请输入模板关键字"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="模板备注" prop="brief">
            <el-input v-model="editForm.brief" placeholder="请输入模板备注"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="modifyTemplate">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {updateTemplate} from "@/api/template/template";
import {getPostOrDeleteData} from "@/utils/code";

export default {
  name: "editTemplate",
  data() {
    return {
      editForm: {}, //修改
      editDialogVisible: false,
      // 规则
      rules: {
            name: [{required: true, message: "模板名称不能为空", trigger: "blur"}],
            path: [{required: true, message: "模板路径不能为空", trigger: "blur"}],
            content: [{required: true, message: "模板内容不能为空", trigger: "blur"}],
            keyword: [{required: true, message: "模板关键字不能为空", trigger: "blur"}],
            brief: [{required: true, message: "模板备注不能为空", trigger: "blur"}],
      },
    }
  },
  methods: {
    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },
    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },
    modifyTemplate() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        updateTemplate(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false;
          }
        })
      });
    },
  }
}
</script>

<style scoped>

</style>